<!-- <div class="py-5">
    <div class="container">
      <div class="row">
        <div class="col-md-6 offset-md-3">
          <div class="card">
            <div class="card-header">Admin Login</div>
            <div class="card-body">
			  <div *ngIf="rtnData && invalidloginMsg!=''" class="alert alert-danger">
				  {{invalidloginMsg}}
			  </div>
              <form class="" #acploginForm="ngForm" (ngSubmit)="acpadminLogin(acploginForm)" >
                <div class="form-group"> <label for="exampleInputUsername">User Name</label>
                  <input type="text" class="form-control" id="exampleInputUsername"  placeholder="Enter User Name" name="usrName" [(ngModel)]='usrName' > 
					<div *ngIf="rtnData && rtnData.message.usrName" class="alert alert-danger">
					  {{rtnData.message.usrName}}
					</div>
				</div>
                <div class="form-group"> <label for="exampleInputPassword">Password</label>
					<input type="password" class="form-control" id="exampleInputPassword" placeholder="Password"  name="usrPwd" [(ngModel)]='usrPwd'> 
					<div *ngIf="rtnData && rtnData.message.usrPwd" class="alert alert-danger">
					  {{rtnData.message.usrPwd}}
					</div>
				</div>
                <a href="#">Forgot Password</a>
                <button [disabled]="!acploginForm.form.valid" type="submit" class="btn btn-primary pull-right">Submit</button>
              </form>
            </div>
          </div>  
        </div>
      </div>
    </div>
</div> -->

	 
	  
<div class="container-login100"  style="background:#f1fab7;">
	 
  <div class="wrap-login100"> 


    <div class="container">

      <div class="row">

        <div class="col-md-7 mx-auto">
          <div class="loginlogo" style="text-align: center;">
           <!--<img [src]="logoPath" *ngIf='logoPath!=""' />
            <img src="assets/img/logo.png" alt="logo" *ngIf='logoPath==""'>--> 
            <span style="color:#000; font-weight:600; font-size:30px; display: block;">{{ACPprojectName}}</span>	 
           </div>
          <div class="login-box">
          <div class="col-md-12">
            <div class="row align-items-center">
              <div class="col-md-5 p-0">
                <div class="login-content">
                  <div class="loginlogo text-center">
                    <img src="assets/img/logo.png" alt="logo">
                  </div>
                  <div>
                    <h2>Hello Friend!</h2>
                    <span class="heading-border"></span>
                   
                    <p class="login-welcome">Welcome back, Please login in to your account</p>
                  </div>
                  
                </div>

              </div>
              <div class="col-md-7 p-0">
                <div class="login-form">
                  <form class="login100-form" (ngSubmit)="acpadminLogin(acploginForm)" #acploginForm="ngForm"> 
  
                    <span class="login100-form-title mb-4">
                      Admin Login
                    </span> 
            
                    <div class="wrap-input100 validate-input mb-3" data-validate = "Username is required">
                      <input class="input100" type="text" placeholder="Enter User Name" name="usrName" [(ngModel)]='usrName'>
                      <span class="focus-input100"></span>
                      <span class="symbol-input100">
                        <i class="fa fa-user"></i>
                      </span>
                      <div *ngIf="rtnData && rtnData.message.usrName" class="error">
                        {{rtnData.message.usrName}}
                      </div>
                    </div>
            
                    <div class="wrap-input100 validate-input mb-3" data-validate = "Password is required">
                      <input class="input100" type="password" name="pass" placeholder="Password" [(ngModel)]='usrPwd' name="usrPwd">
                      <span class="focus-input100"></span>
                      <span class="symbol-input100">
                        <i class="fa fa-lock"></i>
                      </span>
                      <div *ngIf="rtnData && rtnData.message.usrPwd" class="error">
                        {{rtnData.message.usrPwd}}
                      </div>
                    </div>
            
                <!--<div class="captcha">
                      <!--img src="assets/img/recaptcha.jpg"--><!--
                   <re-captcha [(ngModel)]="captcha" name="captcha" siteKey="6Lc6QLAUAAAAAInZHVxLl1hz2ahplDR1q07KzXP0" (resolved)="resolved($event)" ></re-captcha>
                       
                  <div *ngIf="rtnData && rtnData.message.captcha" class="errorcapcha">
                    {{rtnData.message.captcha}}
                  </div>
                    </div>
                    <!-- <div class="captcha">
                      <img src="assets/img/recaptcha.jpg">
                    </div> -->
                    <div class="text-center col mt-2">
                      <span class="forgot" (click)="goForgot()">
                        Forgot Password?
                      </span>
                    </div>
                    <div class="container-login100-form-btn mt-3">
                      <button class="login100-form-btn" [disabled]="!acploginForm.form.valid" type="submit">
                        Submit
                      </button>
                    </div>
                    
                    <div *ngIf="rtnData && invalidloginMsg!=''" class="alert error">
                        {{invalidloginMsg}}
                    </div>
            
                    
                  </form>
                  </div>

                  </div>
                  </div>


      </div>
    </div>
    
    



  </div>
  <div class="loginfooter">
      Copyright &copy; 2019.  <a href="http://www.sifytechnologies.com/" target="_blank">Sify Technologies Limited</a>. All rights reserved.
  </div>
</div>
